import { Meteor } from 'meteor/meteor'
import { dispatch } from '../store'
import { SET_CALLPARTNER } from '../reducers/callPartner'

export const fetchCallPartner = async () => {
  const callPartner = await Meteor.promise('getCallPartner')

  dispatch({
    type: SET_CALLPARTNER,
    payload: callPartner,
  })
}
